import React, { useContext, Suspense, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Routes, Route, Outlet, Redirect, useLocation } from 'react-router-dom'
import { Loading } from '../Components/Spinner/Loading'
import './LayoutPage.css'
import { LoginPage } from './LoginPage'
import { LoginFromTempLinkPage } from './LoginFromTempLinkPage'

import { UserContext } from '../Providers/UserProvider'
import { MessageContext } from '../Providers/MessageProvider'
import UserService from '../Services/UserService'
import useMessage from '../Hooks/useMessage'
import { ExitPage } from './ExitPage'
import { PasswordRecoverPage } from './PasswordRecoverPage'
import axiosInstance from '../Services/http'
import ServerErrorPage from '../ServerErrorPage'
import FinishTestPage from './FinishTestPage'

const ChallengerIndexPage = React.lazy(() => import('./Challenger'))
const AdminIndexPage = React.lazy(() => import('./Admin'))
const SysAdminIndexPage = React.lazy(() => import('./SysAdmin'))
const SecretaryIndexPage = React.lazy(() => import('./Secretary'))
const ExpertIndexPage = React.lazy(() => import('./Expert'))

// import SideBarContainer from "../Containers/SideBar";
// import ChallengerIndexPage from "./Challenger/IndexPage";
// import AdminIndexPage from "./Admin/IndexPage";
// import SysAdminIndexPage from "./SysAdmin/IndexPage";
// import SecretaryIndexPage from "./Secretary/IndexPage";
// import ExpertIndexPage from "./Expert/IndexPage";

export default function LayoutPage() {
	const { login } = useContext(UserContext)
	const { message, addMessage, removeMessage } = useMessage()

	let navigate = useNavigate()
	const { pathname } = useLocation()

	useEffect(() => {
		if (pathname === '/finish-test') {
			return
		}

		if (!window.location.pathname.includes('/login/temp/token/')) {
			UserService.getUser().then(
				response => {
					if (response?.data) {
						login(response?.data)

						switch (response?.data?.roles[0]) {
							case 'challenger':
								if (pathname.startsWith('/challenger/')) navigate(pathname)
								else navigate('/challenger/notifications')
								break

							case 'administrator':
								if (pathname.startsWith('/admin/')) navigate(pathname)
								else navigate('/admin/statistic')
								break

							case 'system_administrator':
								if (pathname.startsWith('/sysadmin/')) navigate(pathname)
								else navigate('/sysadmin/users')
								break

							case 'technical_secretary':
								if (pathname.startsWith('/secretary/')) navigate(pathname)
								else navigate('/secretary/interviews')
								break

							case 'expert':
								if (pathname.startsWith('/expert/')) navigate(pathname)
								else navigate('/expert/interview')
								break

							default:
								break
						}
					}
				},
				error => {
					if (
						error?.response?.status == 401 &&
						!window.location.pathname.includes('/password/reset/')
					) {
						navigate('/')
					} else if (error?.response?.status == 500) {
						navigate('/500')
					}
					console.log('Layout error', error)
					// const resMessage =
					//   error?.response?.data?.message ||
					//   error.message ||
					//   error.toString();
					// addMessage(resMessage, "status");
				}
			)
			axiosInstance.interceptors.response.use(
				function (response) {
					// Any status code that lie within the range of 2xx cause this function to trigger
					// Do something with response data
					return response
				},
				function (error) {
					// Any status codes that falls outside the range of 2xx cause this function to trigger
					// Do something with response error

					if (error?.response?.data?.error_messages) {
						Object.values(error?.response?.data?.error_messages).map(
							message => {
								return addMessage(message[0], 'error')
							}
						)
					} else {
						if (error.response.status == 401) {
							addMessage(error?.response?.data?.message, 'error')
						} else {
							const resMessage =
								error?.response?.data?.error_message ||
								// error?.response?.data?.message ||
								error.message ||
								error.toString()
							addMessage(resMessage, 'error')
						}
					}
					return Promise.reject(error)
				}
			)
		}
	}, [])

	return (
		//TODO: Suspense не имеет ответа(promise) или через powers сделать нужно из за этого и не работает
		<Suspense fallback={<Loading />}>
			<Routes>
				<Route path='/' element={<LoginPage />} />
				<Route
					path='/password/reset/:token'
					element={<PasswordRecoverPage />}
				/>
				<Route path='/exit' element={<ExitPage />} />
				<Route
					path='/login/temp/token/:token'
					element={<LoginFromTempLinkPage />}
				/>
				<Route path='/login' element={<LoginPage />} />
				<Route path='/finish-test' element={<FinishTestPage />} />
				<Route path='/challenger/*' element={<ChallengerIndexPage />} />
				<Route path='/expert/*' element={<ExpertIndexPage />} />
				<Route path='/admin/*' element={<AdminIndexPage />} />
				<Route path='/sysadmin/*' element={<SysAdminIndexPage />} />
				<Route path='/secretary/*' element={<SecretaryIndexPage />} />
				<Route path='/500' element={<ServerErrorPage />} />
			</Routes>
			<Outlet />
		</Suspense>
	)
}
